import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { id: "MoveEnrolmentsToOrganisation" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { key: 2 }
const _hoisted_5 = {
  key: 0,
  class: "MoveEnrolmentsContainer"
}
const _hoisted_6 = { class: "SearchContainer" }
const _hoisted_7 = { class: "OrganisationID" }
const _hoisted_8 = {
  key: 1,
  class: "MoveEnrolmentsContainer"
}
const _hoisted_9 = { class: "OrganisationName" }
const _hoisted_10 = { class: "ButtonsContainer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCollapsed && _ctx.isChangeOrganisationAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _cache[7] || (_cache[7] = _createElementVNode("p", { class: "MoveEnrolmentsTitle" }, "Change organisation:", -1 /* CACHED */)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.expand())),
            class: "NavigatorButton MoveEnrolmentsButton"
          }, " Change organisation")
        ]))
      : _createCommentVNode("v-if", true),
    (_ctx.isCollapsed && !_ctx.isChangeOrganisationAvailable)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[8] || (_cache[8] = [
          _createStaticVNode("<p class=\"MoveEnrolmentsTitle\">Change organisation:</p><div class=\"NotAvailableWarning\"><i class=\"lnr-clipboard-alert WarningIcon\"></i><p class=\"WarningText\"> Organisation cannot be changed for enrolments that have been shared with the client. </p><p class=\"WarningText\"> Please revise your selection and try again. </p></div>", 2)
        ])))
      : _createCommentVNode("v-if", true),
    (_ctx.isExpanded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("button", {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.collapse())),
            class: "ExitButton TransitionBackButton"
          }, _cache[9] || (_cache[9] = [
            _createElementVNode("i", { class: "lnr-arrow-left BackArrow" }, null, -1 /* CACHED */)
          ])),
          (!_ctx.isConfirmationPromptVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _cache[12] || (_cache[12] = _createElementVNode("p", null, "Move the selected enrolment(s) to:", -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_6, [
                  _cache[11] || (_cache[11] = _createElementVNode("i", { class: "lnr-magnifier SearchIcon" }, null, -1 /* CACHED */)),
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchBoxInput) = $event)),
                    class: "SearchInput",
                    placeholder: "Type in an organisation ID"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelText, _ctx.searchBoxInput]
                  ]),
                  (_ctx.searchBoxInput)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: "SearchClear",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.resetOrganisation()))
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "lnr-cross" }, null, -1 /* CACHED */)
                      ])))
                    : _createCommentVNode("v-if", true)
                ]),
                (_ctx.organisation)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showConfirmationPrompt())),
                      class: "SearchResult"
                    }, [
                      _createTextVNode(_toDisplayString(_ctx.organisation.name) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_7, "(ID: " + _toDisplayString(_ctx.organisation.identity) + ")", 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ]))
            : _createCommentVNode("v-if", true),
          (_ctx.isConfirmationPromptVisible)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _cache[13] || (_cache[13] = _createElementVNode("p", null, "Move selected enrolment(s) to:", -1 /* CACHED */)),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.organisation.name), 1 /* TEXT */),
                _cache[14] || (_cache[14] = _createElementVNode("p", { class: "WarningContainer" }, [
                  _createElementVNode("i", { class: "lnr-notification-circle NotificationIcon" }),
                  _createElementVNode("span", { class: "NotificationText" }, [
                    _createTextVNode("Please note that the status of these enrolments will be changed to "),
                    _createElementVNode("span", { class: "IdentifiedStatus" }, "\"Identified\""),
                    _createTextVNode(".")
                  ])
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("button", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmOrganisationChange())),
                    class: "DriverButton"
                  }, " Ok "),
                  _createElementVNode("button", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.cancelOrganisationChange())),
                    class: "ExitButton CancelButton"
                  }, " Cancel ")
                ])
              ]))
            : _createCommentVNode("v-if", true)
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}